import {useState, useEffect, useContext} from "react";
import styles from "./IntegrationPageParent.module.css";
import ADFSSamlForm from "./SAML/ADFSSamlForm";
import AzureSamlForm from "./SAML/AzureSamlForm";
import DCAMSamlForm from "./SAML/DCAMSamlForm";
import GoogleSamlForm from "./SAML/GoogleSamlForm";
import ShibbolethSamlForm from "./SAML/ShibbolethSamlForm";
import { YuJaDropdown } from "../../../components/standardization/YuJaDropdown";
import {useLoading, YuJaGlobalState} from "../../../utils/LoadingContext";
import {
  INTEGRATION_TYPES,
  CREATION_ROLES,
  LMS_TYPE_PLACEHOLDER,
  INTEGRATION_TYPES_DETAILS,
  INTEGRATION_TYPES_LOWERCASE,
  INTEGRATION_TYPE_PLACEHOLDER,
  LMS_ACCESS_KEY_FIELDS,
  MENU_LIST,
  TEXTBOX,
  ROLES, SAVE_CHANGES_TEXT, DISCARD_CHANGES_TEXT
} from "../../../utils/constants";
import { LMS_DISCARD_CHANGES_SUCCESS } from "../../../utils/toast-message-constants";
import { notifySuccess } from "../../../utils/helpers";
import { InstitutionApiCalls } from "../../../apis/InstitutionApiCalls";
import YuJaButton from "../../../components/standardization/YuJaButton";
import defaultConfig from "./SSOConfig.json";
import GeneralLTIPage from "./LTI/GeneralLTIPage";
import CrossIntegration from "./CrossIntegration";
import { Tab, Tabs } from "react-bootstrap";
import GeneralLMSAPIPage from "./LTI/GeneralLMSAPIPage";
import PPTInstallGuidePage from "../../PPTPlugin/PPTInstallGuidePage";
import { useLocalStorageNew } from "../../../hooks/useLocalStorageNew";
import GoogleSlidesIntegrationPage from "./GoogleSlidesIntegrationPage";
import useHostResource from "../../../hooks/useHostResource";
import useNavigationGuard from "../../../hooks/useNavigationGuard";
import DiscardChangesConfirmationModal from "../../../components/modals/DiscardChangesConfirmationModal";

export default function IntegrationPageParent({ setPageIdentifier }) {
  const [, getSession] = useLocalStorageNew("session", {});
  let {selectedIntegrationBtn, setSelectedIntegrationBtn, globalHostResource} = useContext(YuJaGlobalState);
  const { role = '' } = getSession();

  const [dataReady, setDataReady] = useState(false);
  const [showDiscardConfirm, setShowDiscardConfirm] = useState(false);
  // const [selectedMenu, setSelectedMenu] = useState(INTEGRATION_TYPES.LTI);
  const [configJson, setConfigJson] = useState({});
  const { loading, setLoading } = useLoading();
  const { saveSSODetails, saveLMSConfig } = InstitutionApiCalls();
  let {updateIntegrationType} = useHostResource(window.location.hostname);
  // Last-loaded (or last-saved) snapshot per LMS type, keyed by INTEGRATION_TYPES value (e.g. "CANVAS").
  // Used to detect unsaved changes for whichever LMS type is currently selected so Save/Discard can be
  // enabled/disabled accordingly. GeneralLTIPage and GeneralLMSAPIPage both fetch/populate the same
  // canvasForm/blackboardForm/d2lForm/moodleForm state, so both report freshly-loaded data here via
  // onLmsFormLoaded.
  const [rawLmsForms, setRawLmsForms] = useState({});
  const [showChromeExts, setShowChromeExts] = useState(false);
  const [ssoURL, setSSOURL] = useState("");
  const [nameIdFormat, setNameIdFormat] = useState("");
  const [remoteLogoutUrl, setRemoteLogouUrl] = useState("");
  const [certificateFingerPrint, setCertificateFingerPrint] = useState("");
  const [logoutUrl, setLogoutUrl] = useState("");
  const [signatureEnabled, setSignatureEnabled] = useState(false);
  const [givenNameAttribute, setGiveNameAttribute] = useState("");
  const [familyNameAttribute, setFamilyNameAttribute] = useState("");
  const [emailAttribute, setEmailAttribute] = useState("");
  const [roleAttribute, setRoleAttribute] = useState("");
  const [itManagerMapping, setITManagerMapping] = useState("");
  const [instructorMapping, setInstructorMapping] = useState("");
  const [linkageAttribute, setLinkageAttribute] = useState("");
  const [fallbackToEmail, setFallbackToEmail] = useState(true);
  const [selectedMenuLTI, setSelectedMenuLTI] = useState("Canvas");
  const [blackboardForm, setBlackboardForm] = useState({
    studentRole: "",
    instructorRole: "",
    graderRole: "",
    courseBuilderRole: "",
    teachingAssistantRole: "",
    guestRole: "",
    adminRole: "",
    otherRole: "",
    autoProvisionUser: false,
    autoSyncData: false,
    autoSyncCourseData: false,
    autoProvisionCourse: false,
    iss: "",
    clientId: "",
    oidcEndpoint: "",
    jwksEndpoint: "",
    oAuth2Endpoint: "",
    deploymentId: "",
    autoLinkCourse: false,
    ltiCourseLinkageAttri: "",
    autoLinkUser: false,
    ltiUserLinkageAttribute: "",
    domain: "",
    lmsApiLink: "",
    apiAccessToken: "",
    appKey: "",
    appSecret: "",
    clientIDAPI: "",
    fallbackToCourseCodeLms: false
  });

  const [activeTab, setActiveTab] = useState(() => {
    if ([ROLES.ADMINISTRATOR.value, ROLES.IT_MANAGER.value].includes(role)) {
      return "integration";
    }

    return "PPTIntegration";
  });

  useEffect(() => {
    setPageIdentifier(MENU_LIST.INTEGRATIONS.name);
  }, []);

  const [canvasForm, setCanvasForm] = useState({
    "adminRole": "",
    "teacherRole": "",
    "teachingAssistantRole": "",
    "designerRole": "",
    "studentRole": "",
    "observerRole": "",
    "autoProvisionUser": false,
    "autoSyncData": false,
    "autoSyncCourseData": false,
    "autoProvisionCourse": false,
    "iss": "",
    "clientId": "",
    "oidcEndpoint": "",
    "jwksEndpoint": "",
    "oAuth2Endpoint": "",
    "deploymentId": "",
    "autoLinkCourse": false,
    "ltiCourseLinkageAttri": "",
    "autoLinkUser": false,
    "ltiUserLinkageAttribute": "",
    domain: "",
    lmsApiLink: "",
    apiAccessToken: "",
    apiCourseLinkageAttr: "",
    apiUserLinkageAttr: "",
    fallbackToCourseCodeLms: false
  });

  const [d2lForm, setD2lForm] = useState({
    studentRole: "",
    instructorRole: "",
    graderRole: "",
    courseBuilderRole: "",
    teachingAssistantRole: "",
    guestRole: "",
    adminRole: "",
    otherRole: "",
    autoProvisionUser: false,
    autoSyncData: false,
    autoSyncCourseData: false,
    autoProvisionCourse: false,
    iss: "",
    clientId: "",
    oidcEndpoint: "",
    jwksEndpoint: "",
    oAuth2Endpoint: "",
    deploymentId: "",
    autoLinkCourse: false,
    ltiCourseLinkageAttri: "",
    autoLinkUser: false,
    ltiUserLinkageAttribute: "",
    domain: "",
    lmsApiLink: "",
    apiAccessToken: "",
    apiCourseLinkageAttr: "",
    apiUserLinkageAttr: "",
    fallbackToCourseCodeLms: false
  });

  const [moodleForm, setMoodleForm] = useState({
    studentRole: "",
    instructorRole: "",
    graderRole: "",
    courseBuilderRole: "",
    teachingAssistantRole: "",
    guestRole: "",
    adminRole: "",
    otherRole: "",
    autoProvisionUser: false,
    autoSyncData: false,
    autoSyncCourseData: false,
    autoProvisionCourse: false,
    iss: "",
    clientId: "",
    oidcEndpoint: "",
    jwksEndpoint: "",
    oAuth2Endpoint: "",
    deploymentId: "",
    autoLinkCourse: false,
    ltiCourseLinkageAttri: "",
    autoLinkUser: false,
    ltiUserLinkageAttribute: "",
    domain: "",
    lmsApiLink: "",
    apiAccessToken: "",
    apiCourseLinkageAttr: "",
    apiUserLinkageAttr: "",
    fallbackToCourseCodeLms: false
  });

  const optionDataLTI = [INTEGRATION_TYPES_LOWERCASE.CANVAS, INTEGRATION_TYPES_LOWERCASE.BLACKBOARD, INTEGRATION_TYPES_LOWERCASE.MOODLE, INTEGRATION_TYPES.D2L];
  const optionDataLMSAPI = [INTEGRATION_TYPES_LOWERCASE.CANVAS, INTEGRATION_TYPES_LOWERCASE.BLACKBOARD, INTEGRATION_TYPES_LOWERCASE.MOODLE, INTEGRATION_TYPES_LOWERCASE.D2L];
  const optionData = [
    { label: INTEGRATION_TYPES_DETAILS.LTI, value: INTEGRATION_TYPES.LTI },
    { label: INTEGRATION_TYPES_DETAILS.ADFS, value: INTEGRATION_TYPES.ADFS },
    { label: INTEGRATION_TYPES_DETAILS.SHIBBOLETH, value: INTEGRATION_TYPES.SHIBBOLETH },
    { label: INTEGRATION_TYPES_DETAILS.DCAM, value: INTEGRATION_TYPES.DCAM },
    { label: INTEGRATION_TYPES_DETAILS.GOOGLE, value: INTEGRATION_TYPES.GOOGLE },
    { label: INTEGRATION_TYPES_DETAILS.AZURE, value: INTEGRATION_TYPES.AZURE },
    { label: INTEGRATION_TYPES_DETAILS.LMS_API, value: INTEGRATION_TYPES.LMS_API },
  ];


  const applyIntegrationSelect = (item) => {
    setSelectedIntegrationBtn(item.value);
  };

  const getIntegrationType = () => {
    if (selectedIntegrationBtn === INTEGRATION_TYPES.ADFS) { return INTEGRATION_TYPES.ADFS }
    else if (selectedIntegrationBtn === INTEGRATION_TYPES.SHIBBOLETH) { return INTEGRATION_TYPES.SHIBBOLETH }
    else if (selectedIntegrationBtn === INTEGRATION_TYPES.DCAM) { return INTEGRATION_TYPES.DCAM }
    else if (selectedIntegrationBtn === INTEGRATION_TYPES.GOOGLE) { return INTEGRATION_TYPES.GOOGLE }
    else if (selectedIntegrationBtn === INTEGRATION_TYPES.AZURE) { return INTEGRATION_TYPES.AZURE }
  };

  const applyLMSChange = (item) => {
    setSelectedMenuLTI(item);
  };

  const handleSave = () => {
    let copy = {};
    if (!configJson || !Object.keys(configJson).length) {
      copy = JSON.parse(JSON.stringify(defaultConfig));
    } else {
      copy = JSON.parse(JSON.stringify(configJson));
    }
    copy.samlSsoUrl = ssoURL;
    copy.nameIdFormat = nameIdFormat;
    copy.remoteLogoutUrl = remoteLogoutUrl;
    copy.certificateFingerPrint = certificateFingerPrint;
    copy.logoutUrl = logoutUrl;
    copy.signatureEnabled = signatureEnabled;
    copy.givenNameAttribute = givenNameAttribute;
    copy.familyNameAttribute = familyNameAttribute;
    copy.emailAttribute = emailAttribute;
    copy.roleAttribute = roleAttribute;
    copy.itManagerMapping = itManagerMapping;
    copy.instructorMapping = instructorMapping;
    copy.linkageAttribute = linkageAttribute;
    copy.fallbackToEmail = fallbackToEmail;
    setConfigJson(copy);
    setLoading(true);
    let intType = getIntegrationType();
    saveSSODetails(copy, intType).then((res) => {
      if (res) {
        updateIntegrationType(copy, intType);
      }
    }).finally(() => setLoading(false));
  };

  const handleSaveBlackboard = async () => {
    if (blackboardForm.adminRole === undefined || blackboardForm.adminRole === "" || !(blackboardForm.adminRole in CREATION_ROLES)) {
      blackboardForm.adminRole = CREATION_ROLES.IT_MANAGER.value;
    }
    if (blackboardForm.instructorRole === undefined || blackboardForm.instructorRole === "" || !(blackboardForm.instructorRole in CREATION_ROLES)) {
      blackboardForm.instructorRole = CREATION_ROLES.CREATOR.value;
    }
    if (blackboardForm.teachingAssistantRole === undefined || blackboardForm.teachingAssistantRole === "" || !(blackboardForm.teachingAssistantRole in CREATION_ROLES)) {
      blackboardForm.teachingAssistantRole = CREATION_ROLES.CREATOR.value;
    }
    if (blackboardForm.graderRole === undefined || blackboardForm.graderRole === "" || !(blackboardForm.graderRole in CREATION_ROLES)) {
      blackboardForm.graderRole = CREATION_ROLES.CREATOR.value;
    }
    if (blackboardForm.courseBuilderRole === undefined || blackboardForm.courseBuilderRole === "" || !(blackboardForm.courseBuilderRole in CREATION_ROLES)) {
      blackboardForm.courseBuilderRole = CREATION_ROLES.CREATOR.value;
    }
    if (blackboardForm.studentRole === undefined || blackboardForm.studentRole === "" || !(blackboardForm.studentRole in CREATION_ROLES)) {
      blackboardForm.studentRole = CREATION_ROLES.VIEWER.value;
    }
    if (blackboardForm.otherRole === undefined || blackboardForm.otherRole === "" || !(blackboardForm.otherRole in CREATION_ROLES)) {
      blackboardForm.otherRole = CREATION_ROLES.VIEWER.value;
    }
    if (blackboardForm.guestRole === undefined || blackboardForm.guestRole === "" || !(blackboardForm.guestRole in CREATION_ROLES)) {
      blackboardForm.guestRole = CREATION_ROLES.VIEWER.value;
    }
    saveLMSConfig(blackboardForm, INTEGRATION_TYPES.BLACKBOARD).then((res) => {
      if (res) {
        updateIntegrationType(blackboardForm, INTEGRATION_TYPES.BLACKBOARD);
        onLmsFormLoaded(INTEGRATION_TYPES.BLACKBOARD, blackboardForm);
      }
    });


  };

  const handleSaveCanvas = async () => {
    if (canvasForm.adminRole === undefined || canvasForm.adminRole === "" || !(canvasForm.adminRole in CREATION_ROLES)) {
      canvasForm.adminRole = CREATION_ROLES.IT_MANAGER.value;
    }
    if (canvasForm.teacherRole === undefined || canvasForm.teacherRole === "" || !(canvasForm.teacherRole in CREATION_ROLES)) {
      canvasForm.teacherRole = CREATION_ROLES.CREATOR.value;
    }
    if (canvasForm.teachingAssistantRole === undefined || canvasForm.teachingAssistantRole === "" || !(canvasForm.teachingAssistantRole in CREATION_ROLES)) {
      canvasForm.teachingAssistantRole = CREATION_ROLES.CREATOR.value;
    }
    if (canvasForm.designerRole === undefined || canvasForm.designerRole === "" || !(canvasForm.designerRole in CREATION_ROLES)) {
      canvasForm.designerRole = CREATION_ROLES.CREATOR.value;
    }
    if (canvasForm.studentRole === undefined || canvasForm.studentRole === "" || !(canvasForm.studentRole in CREATION_ROLES)) {
      canvasForm.studentRole = CREATION_ROLES.VIEWER.value;
    }
    if (canvasForm.observerRole === undefined || canvasForm.observerRole === "" || !(canvasForm.observerRole in CREATION_ROLES)) {
      canvasForm.observerRole = CREATION_ROLES.VIEWER.value;
    }
    saveLMSConfig(canvasForm, INTEGRATION_TYPES.CANVAS).then((res) => {
      if (res) {
        updateIntegrationType(canvasForm, INTEGRATION_TYPES.CANVAS);
        onLmsFormLoaded(INTEGRATION_TYPES.CANVAS, canvasForm);
      }
    });
  };

  const handleSaveD2L = async () => {
    if (d2lForm.adminRole === undefined || d2lForm.adminRole === "" || !(d2lForm.adminRole in CREATION_ROLES)) {
      d2lForm.adminRole = CREATION_ROLES.IT_MANAGER.value;
    }
    if (d2lForm.instructorRole === undefined || d2lForm.instructorRole === "" || !(d2lForm.instructorRole in CREATION_ROLES)) {
      d2lForm.instructorRole = CREATION_ROLES.CREATOR.value;
    }
    if (d2lForm.studentRole === undefined || d2lForm.studentRole === "" || !(d2lForm.studentRole in CREATION_ROLES)) {
      d2lForm.studentRole = CREATION_ROLES.VIEWER.value;
    }
    saveLMSConfig(d2lForm, INTEGRATION_TYPES.D2L).then((res) => {
      if (res) {
        updateIntegrationType(d2lForm, INTEGRATION_TYPES.D2L);
        onLmsFormLoaded(INTEGRATION_TYPES.D2L, d2lForm);
      }
    });
  };

  const handleSaveMoodle = async () => {
    if (moodleForm.adminRole === undefined || moodleForm.adminRole === "" || !(moodleForm.adminRole in CREATION_ROLES)) {
      moodleForm.adminRole = CREATION_ROLES.IT_MANAGER.value;
    }
    if (moodleForm.instructorRole === undefined || moodleForm.instructorRole === "" || !(moodleForm.instructorRole in CREATION_ROLES)) {
      moodleForm.instructorRole = CREATION_ROLES.CREATOR.value;
    }
    if (moodleForm.studentRole === undefined || moodleForm.studentRole === "" || !(moodleForm.studentRole in CREATION_ROLES)) {
      moodleForm.studentRole = CREATION_ROLES.VIEWER.value;
    }
    saveLMSConfig(moodleForm, INTEGRATION_TYPES.MOODLE).then((res) => {
      if (res) {
        updateIntegrationType(moodleForm, INTEGRATION_TYPES.MOODLE);
        onLmsFormLoaded(INTEGRATION_TYPES.MOODLE, moodleForm);
      }
    });
  };

  // Called by GeneralLTIPage/GeneralLMSAPIPage whenever they fetch fresh data for an LMS type (and by
  // the handleSave* functions above right after a successful save) - captures the "nothing to save yet"
  // baseline for that type so hasLmsChanges can detect edits against it.
  const onLmsFormLoaded = (intType, data) => {
    setRawLmsForms(prev => ({...prev, [intType]: JSON.parse(JSON.stringify(data))}));
  };

  const getCurrentLmsFormType = () => {
    if (selectedMenuLTI === INTEGRATION_TYPES_LOWERCASE.CANVAS) return INTEGRATION_TYPES.CANVAS;
    if (selectedMenuLTI === INTEGRATION_TYPES_LOWERCASE.BLACKBOARD) return INTEGRATION_TYPES.BLACKBOARD;
    if (selectedMenuLTI === INTEGRATION_TYPES_LOWERCASE.D2L) return INTEGRATION_TYPES.D2L;
    if (selectedMenuLTI === INTEGRATION_TYPES_LOWERCASE.MOODLE) return INTEGRATION_TYPES.MOODLE;
    return null;
  };

  const getCurrentLmsForm = () => {
    if (selectedMenuLTI === INTEGRATION_TYPES_LOWERCASE.CANVAS) return canvasForm;
    if (selectedMenuLTI === INTEGRATION_TYPES_LOWERCASE.BLACKBOARD) return blackboardForm;
    if (selectedMenuLTI === INTEGRATION_TYPES_LOWERCASE.D2L) return d2lForm;
    if (selectedMenuLTI === INTEGRATION_TYPES_LOWERCASE.MOODLE) return moodleForm;
    return null;
  };

  // Only meaningful for the LTI/LMS API sections, which both edit canvasForm/blackboardForm/d2lForm/
  // moodleForm. SAML sections aren't tracked yet (their fetch lives 2 levels deeper, in 5 separate
  // GeneralXTab.js components) so Save there keeps its prior always-enabled behavior and Discard stays
  // disabled.
  const isLmsSectionActive = selectedIntegrationBtn === INTEGRATION_TYPES.LTI || selectedIntegrationBtn === INTEGRATION_TYPES.LMS_API;

  const hasLmsChanges = () => {
    const rawForm = rawLmsForms[getCurrentLmsFormType()];
    if (!rawForm) {
      return false;
    }
    return JSON.stringify(rawForm) !== JSON.stringify(getCurrentLmsForm());
  };

  const handleDiscardLms = () => {
    const rawForm = rawLmsForms[getCurrentLmsFormType()];
    if (!rawForm) {
      return;
    }
    const clone = JSON.parse(JSON.stringify(rawForm));
    if (selectedMenuLTI === INTEGRATION_TYPES_LOWERCASE.CANVAS) setCanvasForm(clone);
    else if (selectedMenuLTI === INTEGRATION_TYPES_LOWERCASE.BLACKBOARD) setBlackboardForm(clone);
    else if (selectedMenuLTI === INTEGRATION_TYPES_LOWERCASE.D2L) setD2lForm(clone);
    else if (selectedMenuLTI === INTEGRATION_TYPES_LOWERCASE.MOODLE) setMoodleForm(clone);
    notifySuccess(LMS_DISCARD_CHANGES_SUCCESS);
  };

  // Only the "Discard Changes" click for pending API access key edits gets a confirmation prompt
  // (matches the risk of losing a just-entered key/secret) - other LMS field discards (domain,
  // linkage attrs, etc.) keep the prior immediate-discard behavior.
  const hasAccessKeyChanges = () => {
    const rawForm = rawLmsForms[getCurrentLmsFormType()];
    const form = getCurrentLmsForm();
    if (!rawForm || !form) {
      return false;
    }
    const fields = LMS_ACCESS_KEY_FIELDS[selectedMenuLTI] || [];
    return fields.some(f => (rawForm[f] || "") !== (form[f] || ""));
  };

  const requestDiscardLms = () => {
    if (hasAccessKeyChanges()) {
      setShowDiscardConfirm(true);
    } else {
      handleDiscardLms();
    }
  };

  const { confirmationModal: leaveConfirmationModal } = useNavigationGuard({
    hasUnsavedChanges: isLmsSectionActive && hasLmsChanges(),
  });

  const handleIntegrationSelect = (item) => {
    if (!item || item.value === selectedIntegrationBtn) {
      return;
    }
    applyIntegrationSelect(item);
  };

  const handleLMSChange = (item) => {
    if (!item || item === selectedMenuLTI) {
      return;
    }
    applyLMSChange(item);
  };

  const handleSaveLTI = () => {
    if (selectedMenuLTI === INTEGRATION_TYPES_LOWERCASE.BLACKBOARD) {
      handleSaveBlackboard();
    }
    else if (selectedMenuLTI === INTEGRATION_TYPES_LOWERCASE.CANVAS) {
      handleSaveCanvas();
    }
    else if (selectedMenuLTI === INTEGRATION_TYPES_LOWERCASE.MOODLE) {
      handleSaveMoodle();
    }
    else if (selectedMenuLTI === INTEGRATION_TYPES.D2L) {
      handleSaveD2L();
    }
  };

  useEffect(() => {
    if (selectedIntegrationBtn === INTEGRATION_TYPES.LMS_API) {
      setSelectedMenuLTI(INTEGRATION_TYPES_LOWERCASE.CANVAS); // temporary till the time we support API for all the LMS
    } else if (selectedIntegrationBtn === INTEGRATION_TYPES.LTI) {
      setSelectedMenuLTI(INTEGRATION_TYPES_LOWERCASE.CANVAS); // temporary till the time we support API for all the LMS
    }
  }, [selectedIntegrationBtn]);

  useEffect(() => {
    if (globalHostResource.hasOwnProperty("showChromeExtensions")) {
      setShowChromeExts(globalHostResource.showChromeExtensions);
    }
  }, [globalHostResource]);


  // clean the integration btn when activating another tab
  useEffect(() => {
    if (activeTab !== "integration") {
      setSelectedIntegrationBtn("");
    } else if (!selectedIntegrationBtn) {
      setSelectedIntegrationBtn(INTEGRATION_TYPES.LTI);
    }
  }, [activeTab]);

  // change the active tab when click on the Quick setup modal
  useEffect(() => {
    if (!!selectedIntegrationBtn && activeTab !== "integration") {
      setActiveTab("integration")
    }

  }, [selectedIntegrationBtn]);

  return (
      <div className={styles.parentContainer}>
        <div className={styles.mainDiv}>
          <Tabs activeKey={activeTab} onSelect={k => setActiveTab(k)}>
            {[ROLES.ADMINISTRATOR.value, ROLES.IT_MANAGER.value].includes(role) &&
              <Tab eventKey="integration" title="Integration">


                <div style={{ display: "flex", flexDirection: "row", alignItems: "center", flexWrap: "wrap", gap: 20 }}>
                  <div>
                    <div className={styles.platformTitle}>{INTEGRATION_TYPE_PLACEHOLDER}</div>
                    <YuJaDropdown
                        containerStyle={{minWidth: 200}}
                        data={optionData}
                        value={selectedIntegrationBtn}
                        placeholder={INTEGRATION_TYPE_PLACEHOLDER}
                        onChange={handleIntegrationSelect}
                    />
                  </div>
                  {(selectedIntegrationBtn === INTEGRATION_TYPES.LTI) &&
                      <div>
                        <div className={styles.platformTitle}>{LMS_TYPE_PLACEHOLDER}</div>
                        <YuJaDropdown
                            containerStyle={{ minWidth: 200 }}
                            data={optionDataLTI}
                            value={selectedMenuLTI}
                            placeholder={LMS_TYPE_PLACEHOLDER}
                            getOptionLabel={item => item}
                            getOptionValue={item => item}
                            onChange={handleLMSChange}
                        />
                      </div>

                  }
                  {(selectedIntegrationBtn === INTEGRATION_TYPES.LMS_API) &&
                      <div>
                        <div className={styles.platformTitle}>{LMS_TYPE_PLACEHOLDER}</div>
                        <YuJaDropdown
                            containerStyle={{minWidth: 200}}
                            data={optionDataLMSAPI}
                            value={selectedMenuLTI}
                            placeholder={LMS_TYPE_PLACEHOLDER}
                            getOptionLabel={item => item}
                            getOptionValue={item => item}
                            onChange={handleLMSChange}
                        />
                      </div>
                  }
                  <div style={{flex: 1}}/>

                  <YuJaButton
                      type="delete"
                      disabled={!!loading || (isLmsSectionActive && !hasLmsChanges())}
                      onClick={requestDiscardLms}
                  >
                    {DISCARD_CHANGES_TEXT}
                  </YuJaButton>
                  <YuJaButton
                      disabled={!!loading || (isLmsSectionActive && !hasLmsChanges())}
                      isLoading={!!loading}
                      onClick={(selectedIntegrationBtn === INTEGRATION_TYPES.LTI || selectedIntegrationBtn === INTEGRATION_TYPES.LMS_API) ? handleSaveLTI : handleSave}
                  >
                    {SAVE_CHANGES_TEXT}
                  </YuJaButton>
                </div>
                    <div className={styles.fullWidthClass}>
                  {selectedIntegrationBtn === INTEGRATION_TYPES.ADFS &&
                    <ADFSSamlForm
                      setConfigJson={setConfigJson} handleSave={handleSave}
                      ssoURL={ssoURL} setSSOURL={setSSOURL}
                      nameIdFormat={nameIdFormat} setNameIdFormat={setNameIdFormat}
                      remoteLogoutUrl={remoteLogoutUrl} setRemoteLogouUrl={setRemoteLogouUrl}
                      certificateFingerPrint={certificateFingerPrint}
                      setCertificateFingerPrint={setCertificateFingerPrint}
                      logoutUrl={logoutUrl} setLogoutUrl={setLogoutUrl}
                      setSignatureEnabled={setSignatureEnabled}
                      givenNameAttribute={givenNameAttribute} setGiveNameAttribute={setGiveNameAttribute}
                      familyNameAttribute={familyNameAttribute}
                      setFamilyNameAttribute={setFamilyNameAttribute}
                      emailAttribute={emailAttribute} setEmailAttribute={setEmailAttribute}
                      roleAttribute={roleAttribute} setRoleAttribute={setRoleAttribute}
                      itManagerMapping={itManagerMapping} setITManagerMapping={setITManagerMapping}
                      instructorMapping={instructorMapping} setInstructorMapping={setInstructorMapping}
                      linkageAttribute={linkageAttribute} setLinkageAttribute={setLinkageAttribute}
                      fallbackToEmail={fallbackToEmail} setFallbackToEmail={setFallbackToEmail}
                    />
                  }
                  {selectedIntegrationBtn === INTEGRATION_TYPES.SHIBBOLETH &&
                    <ShibbolethSamlForm
                      setConfigJson={setConfigJson} handleSave={handleSave}
                      ssoURL={ssoURL} setSSOURL={setSSOURL}
                      nameIdFormat={nameIdFormat} setNameIdFormat={setNameIdFormat}
                      remoteLogoutUrl={remoteLogoutUrl} setRemoteLogouUrl={setRemoteLogouUrl}
                      certificateFingerPrint={certificateFingerPrint}
                      setCertificateFingerPrint={setCertificateFingerPrint}
                      logoutUrl={logoutUrl} setLogoutUrl={setLogoutUrl}
                      setSignatureEnabled={setSignatureEnabled}
                      givenNameAttribute={givenNameAttribute} setGiveNameAttribute={setGiveNameAttribute}
                      familyNameAttribute={familyNameAttribute}
                      setFamilyNameAttribute={setFamilyNameAttribute}
                      emailAttribute={emailAttribute} setEmailAttribute={setEmailAttribute}
                      roleAttribute={roleAttribute} setRoleAttribute={setRoleAttribute}
                      itManagerMapping={itManagerMapping} setITManagerMapping={setITManagerMapping}
                      instructorMapping={instructorMapping} setInstructorMapping={setInstructorMapping}
                      linkageAttribute={linkageAttribute} setLinkageAttribute={setLinkageAttribute}
                      fallbackToEmail={fallbackToEmail} setFallbackToEmail={setFallbackToEmail}
                    />
                  }
                  {selectedIntegrationBtn === INTEGRATION_TYPES.DCAM &&
                    <DCAMSamlForm
                      setConfigJson={setConfigJson} handleSave={handleSave}
                      ssoURL={ssoURL} setSSOURL={setSSOURL}
                      nameIdFormat={nameIdFormat} setNameIdFormat={setNameIdFormat}
                      remoteLogoutUrl={remoteLogoutUrl} setRemoteLogouUrl={setRemoteLogouUrl}
                      certificateFingerPrint={certificateFingerPrint}
                      setCertificateFingerPrint={setCertificateFingerPrint}
                      logoutUrl={logoutUrl} setLogoutUrl={setLogoutUrl}
                      setSignatureEnabled={setSignatureEnabled}
                      givenNameAttribute={givenNameAttribute} setGiveNameAttribute={setGiveNameAttribute}
                      familyNameAttribute={familyNameAttribute}
                      setFamilyNameAttribute={setFamilyNameAttribute}
                      emailAttribute={emailAttribute} setEmailAttribute={setEmailAttribute}
                      roleAttribute={roleAttribute} setRoleAttribute={setRoleAttribute}
                      itManagerMapping={itManagerMapping} setITManagerMapping={setITManagerMapping}
                      instructorMapping={instructorMapping} setInstructorMapping={setInstructorMapping}
                      linkageAttribute={linkageAttribute} setLinkageAttribute={setLinkageAttribute}
                      fallbackToEmail={fallbackToEmail} setFallbackToEmail={setFallbackToEmail}
                    />
                  }
                  {selectedIntegrationBtn === INTEGRATION_TYPES.GOOGLE &&
                    <GoogleSamlForm
                      setConfigJson={setConfigJson} handleSave={handleSave}
                      ssoURL={ssoURL} setSSOURL={setSSOURL}
                      nameIdFormat={nameIdFormat} setNameIdFormat={setNameIdFormat}
                      remoteLogoutUrl={remoteLogoutUrl} setRemoteLogouUrl={setRemoteLogouUrl}
                      certificateFingerPrint={certificateFingerPrint}
                      setCertificateFingerPrint={setCertificateFingerPrint}
                      logoutUrl={logoutUrl} setLogoutUrl={setLogoutUrl}
                      setSignatureEnabled={setSignatureEnabled}
                      givenNameAttribute={givenNameAttribute} setGiveNameAttribute={setGiveNameAttribute}
                      familyNameAttribute={familyNameAttribute}
                      setFamilyNameAttribute={setFamilyNameAttribute}
                      emailAttribute={emailAttribute} setEmailAttribute={setEmailAttribute}
                      roleAttribute={roleAttribute} setRoleAttribute={setRoleAttribute}
                      itManagerMapping={itManagerMapping} setITManagerMapping={setITManagerMapping}
                      instructorMapping={instructorMapping} setInstructorMapping={setInstructorMapping}
                      linkageAttribute={linkageAttribute} setLinkageAttribute={setLinkageAttribute}
                      fallbackToEmail={fallbackToEmail} setFallbackToEmail={setFallbackToEmail}
                    />
                  }
                  {selectedIntegrationBtn === INTEGRATION_TYPES.AZURE &&
                    <AzureSamlForm
                      setConfigJson={setConfigJson} handleSave={handleSave}
                      ssoURL={ssoURL} setSSOURL={setSSOURL}
                      nameIdFormat={nameIdFormat} setNameIdFormat={setNameIdFormat}
                      remoteLogoutUrl={remoteLogoutUrl} setRemoteLogouUrl={setRemoteLogouUrl}
                      certificateFingerPrint={certificateFingerPrint}
                      setCertificateFingerPrint={setCertificateFingerPrint}
                      logoutUrl={logoutUrl} setLogoutUrl={setLogoutUrl}
                      setSignatureEnabled={setSignatureEnabled}
                      givenNameAttribute={givenNameAttribute} setGiveNameAttribute={setGiveNameAttribute}
                      familyNameAttribute={familyNameAttribute}
                      setFamilyNameAttribute={setFamilyNameAttribute}
                      emailAttribute={emailAttribute} setEmailAttribute={setEmailAttribute}
                      roleAttribute={roleAttribute} setRoleAttribute={setRoleAttribute}
                      itManagerMapping={itManagerMapping} setITManagerMapping={setITManagerMapping}
                      instructorMapping={instructorMapping} setInstructorMapping={setInstructorMapping}
                      linkageAttribute={linkageAttribute} setLinkageAttribute={setLinkageAttribute}
                      fallbackToEmail={fallbackToEmail} setFallbackToEmail={setFallbackToEmail}
                    />
                  }
                  {selectedIntegrationBtn === INTEGRATION_TYPES.LTI &&
                    <GeneralLTIPage
                      selectedMenu={selectedMenuLTI} canvasForm={canvasForm}
                      blackboardForm={blackboardForm}
                      moodleForm={moodleForm} d2lForm={d2lForm}
                      setCanvasForm={setCanvasForm} setBlackboardForm={setBlackboardForm}
                      setMoodleForm={setMoodleForm} setD2lForm={setD2lForm}
                      onLmsFormLoaded={onLmsFormLoaded}
                    />
                  }
                  {selectedIntegrationBtn === INTEGRATION_TYPES.LMS_API &&
                    <GeneralLMSAPIPage
                      selectedMenu={selectedMenuLTI} canvasForm={canvasForm}
                      blackboardForm={blackboardForm}
                      moodleForm={moodleForm} d2lForm={d2lForm}
                      setCanvasForm={setCanvasForm} setBlackboardForm={setBlackboardForm}
                      setMoodleForm={setMoodleForm} setD2lForm={setD2lForm}
                      onLmsFormLoaded={onLmsFormLoaded}
                      rawLmsForms={rawLmsForms}
                    />
                  }
                </div>
                <DiscardChangesConfirmationModal
                  show={showDiscardConfirm}
                  setShow={setShowDiscardConfirm}
                  handleSubmit={async () => {
                    handleDiscardLms();
                    setShowDiscardConfirm(false);
                  }}
                />
              </Tab>
            }
            <Tab eventKey="PPTIntegration" title="PowerPoint Integration">
              <PPTInstallGuidePage />
            </Tab>
            <Tab eventKey="googleSlidesIntegration" title="Google Slides Integration">
              <GoogleSlidesIntegrationPage isActive={activeTab === "googleSlidesIntegration"} />
            </Tab>
            {showChromeExts &&
                <Tab eventKey="extIntegration" title="External Integration">
                  <CrossIntegration />
                </Tab>
            }
          </Tabs>
        </div>
        {leaveConfirmationModal}
      </div>
  );
}
